<div class="container-fluid">
  <div class="row">
    <!-- Columna de la lista de trabajos -->
    <div class="col-lg-4 col-md-12 mb-3">
      <div class="d-flex justify-content-between align-items-center mb-3">
        <h4 class="mb-0">Historial de Órdenes</h4>
        <!-- NUEVO: Botón de exportación masiva -->
        <button class="btn btn-outline-success btn-sm" (click)="openExportModal()">
          <i class="bi bi-file-earmark-excel"></i> Exportar
        </button>
      </div>
      
      <!-- NUEVO: Fila combinada para filtro de mes y barra de búsqueda -->
      <div class="row g-2 mb-3">
        <div class="col-5">
          <select class="form-select form-select-sm" (change)="onDateFilterChange($event)">
            <option *ngFor="let month of availableMonths" [value]="month.value">{{ month.label }}</option>
          </select>
        </div>
        <div class="col-7">
          <input type="text" class="form-control form-control-sm" placeholder="Buscar cliente, caso, bici..." [formControl]="workSearchControl">
        </div>
      </div>

      <div class="list-group history-list">
        <ng-container *ngIf="filteredWorks$ | async as works; else loadingWorksTemplate">
          <div *ngIf="works.length > 0; else noWorksFoundTemplate">
            <a *ngFor="let work of works" href="javascript:void(0);" class="list-group-item list-group-item-action" [class.active]="(selectedWorkId$ | async) === work.id" (click)="selectWork(work)">
              <div class="d-flex w-100 justify-content-between align-items-center">
                <h5 class="mb-1 text-truncate">{{ work.caseNumber }} - {{ work.clientName }}</h5>
                <span class="badge rounded-pill" [ngClass]="{'bg-dark': work.currentStatus === 'Completed', 'bg-danger': work.currentStatus === 'Cancelled'}">{{ getSpanishStatus(work.currentStatus) }}</span>
              </div>
              <p class="mb-1 small text-truncate">{{ work.bikeDescription }}</p>
              <div class="d-flex justify-content-between align-items-center">
                <small>{{ work.entryDate?.toDate() | date:'mediumDate':'':'es-DO' }}</small>
                <!-- Indicador de Validación -->
                <span *ngIf="work.validatedByManager" class="badge bg-success">Validado</span>
              </div>
            </a>
          </div>
          <ng-template #noWorksFoundTemplate>
            <div class="list-group-item">No se encontraron trabajos para la búsqueda actual.</div>
          </ng-template>
        </ng-container>
        <ng-template #loadingWorksTemplate>
          <div class="list-group-item">Cargando historial...</div>
        </ng-template>
      </div>
    </div>

    <!-- Columna de detalles del trabajo -->
    <div class="col-lg-8 col-md-12">
      <div *ngIf="(selectedWorkId$ | async); else noWorkSelected">
        <ng-container *ngIf="{ work: (selectedWorkDetails$ | async), client: (selectedClientDetails$ | async), bike: (selectedBikeDetails$ | async) } as details; else loadingDetails">
          <div *ngIf="details.work && details.client && details.bike" class="card">
            <div class="card-header d-flex justify-content-between align-items-center">
              <h4 class="mb-0 text-truncate">Detalles: {{ details.work.caseNumber }}</h4>
              
              <div class="d-flex align-items-center">
                <!-- Insignia de Validación -->
                <span *ngIf="details.work.validatedByManager" class="badge bg-success fs-6 me-3">
                  <i class="bi bi-check-circle-fill me-1"></i> Validado
                </span>
                
                <!-- NUEVO: Botón de Imprimir Histórico -->
                <button class="btn btn-outline-primary btn-sm" (click)="printWork(details.work, details.client, details.bike)" title="Imprimir Detalles">
                  <i class="bi bi-printer-fill me-1"></i> Imprimir Reporte
                </button>
              </div>
            </div>
            <div class="card-body">
              <div class="row mb-3">
                <div class="col-md-6">
                  <p><strong>Cliente:</strong> {{ details.client.name }}</p>
                  <p><strong>Bicicleta:</strong> {{ details.bike.brand }} {{ details.bike.model || '' }} - {{ details.bike.color }}</p>
                </div>
                <div class="col-md-6">
                  <p><strong>Recepción:</strong> {{ details.work.entryDate?.toDate() | date:'medium':'':'es-DO' }}</p>
                  <p><strong>Total Orden (Calculado Originalmente):</strong> {{ details.work.totalPrice | currency:'DOP':'RD$' }}</p>
                </div>
              </div>

              <!-- ARTÍCULOS CON ASIGNACIÓN LÍNEA POR LÍNEA -->
              <h5 class="mt-4">Artículos Agregados</h5>
              <ul *ngIf="editableItems.length; else noItemsAdded" class="list-group">
                <li *ngFor="let item of editableItems" class="list-group-item flex-column align-items-start">
                  
                  <div class="d-flex justify-content-between align-items-center w-100">
                    <div class="fw-bold">
                      {{ item.productName }} (x{{ item.quantity }})
                      <span class="badge ms-2" [ngClass]="{'bg-primary': item.itemType === 'Labor', 'bg-secondary': item.itemType === 'Part'}">{{ item.itemType === 'Labor' ? 'Mano de Obra' : 'Repuesto' }}</span>
                    </div>
                    
                    <!-- NUEVA LÓGICA DE PRECIOS -->
                    <div class="text-end">
                      <div *ngIf="!((authService.isManager$ | async) && details.work.currentStatus === 'Completed')">
                        <small *ngIf="item.originalPrice" class="text-decoration-line-through text-muted me-2" title="Precio Original">
                          {{ item.originalPrice * item.quantity | currency:"DOP":"RD$" }}
                        </small>
                        <span>{{ item.unitPrice * item.quantity | currency:"DOP":"RD$" }}</span>
                      </div>

                      <div *ngIf="(authService.isManager$ | async) && details.work.currentStatus === 'Completed'" class="d-flex align-items-center justify-content-end gap-2">
                        <small *ngIf="item.originalPrice" class="text-decoration-line-through text-muted" title="Precio Original Guardado">
                          {{ item.originalPrice | currency:"DOP":"RD$" }}
                        </small>
                        <div class="input-group input-group-sm" style="width: 140px;">
                          <span class="input-group-text">RD$</span>
                          <input type="number" class="form-control text-end" [(ngModel)]="item.unitPrice" min="0" title="Precio Unitario">
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- Vista Normal (Solo lectura) -->
                  <div *ngIf="!((authService.isManager$ | async) && details.work.currentStatus === 'Completed') && (item.mechanicName || item.assistantName)" class="small text-muted mt-2">
                     <i class="bi bi-person-fill"></i>
                     {{ item.mechanicName ? 'Mec: ' + item.mechanicName : '' }}
                     {{ item.mechanicName && item.assistantName ? ' | ' : '' }}
                     {{ item.assistantName ? 'Asis: ' + item.assistantName : '' }}
                  </div>

                  <!-- Vista Manager Edit Asignaciones -->
                  <div *ngIf="(authService.isManager$ | async) && details.work.currentStatus === 'Completed'" class="d-flex gap-2 mt-2 p-2 bg-light rounded border border-light-subtle">
                    <select class="form-select form-select-sm" [(ngModel)]="item._assignee1">
                      <option [ngValue]="null">Personal (N/A)</option>
                      <option *ngFor="let emp of allActiveEmployees$ | async" [value]="emp.id">{{ emp.type === 'Mecánico' ? 'Mec' : 'Asis' }}: {{ emp.name }}</option>
                    </select>
                    <select *ngIf="isFullService(item)" class="form-select form-select-sm" [(ngModel)]="item._assignee2">
                      <option [ngValue]="null">Segundo (N/A)</option>
                      <option *ngFor="let emp of allActiveEmployees$ | async" [value]="emp.id">{{ emp.type === 'Mecánico' ? 'Mec' : 'Asis' }}: {{ emp.name }}</option>
                    </select>
                  </div>
                </li>
              </ul>
              <ng-template #noItemsAdded><p>No se agregaron artículos a este trabajo.</p></ng-template>

              <!-- Sección de Estados y Recordatorio de Artículos del Cliente -->
              <hr>
              <div class="row align-items-start">
                <div class="col-lg-7 col-md-12 mb-3">
                  <h5 class="text-secondary"><i class="bi bi-clock-history me-2"></i>Historial de Estados</h5>
                  <ng-container *ngIf="selectedWorkStatus$ | async as statusDoc; else noStatusFound">
                    <p>
                      <strong>Estado Actual:</strong>
                      <span class="badge fs-6 ms-2" [ngClass]="getStatusClass(statusDoc.currentStatus)">{{ getSpanishStatus(statusDoc.currentStatus) }}</span>
                      <br><small class="text-muted">Última act.: {{ statusDoc.lastUpdate?.toDate() | date:'medium':'':'es-DO' }}</small>
                    </p>
                    <div *ngIf="statusDoc.history?.length" class="mt-3 mb-2">
                      <ul class="list-group list-group-flush status-history-list border rounded">
                        <li *ngFor="let entry of statusDoc.history" class="list-group-item list-group-item-light py-2">
                          <div class="d-flex w-100 justify-content-between">
                            <small class="fw-bold">{{ getSpanishStatus(entry.status) }}</small>
                            <small>{{ entry.timestamp?.toDate() | date:'dd/MM/yy hh:mm a':'':'es-DO' }}</small>
                          </div>
                          <small *ngIf="entry.notes" class="d-block text-muted fst-italic">Notas: {{ entry.notes }}</small>
                        </li>
                      </ul>
                    </div>
                  </ng-container>
                  <ng-template #noStatusFound>
                    <div class="alert alert-light border small text-muted">No se encontró información de estado para esta orden.</div>
                  </ng-template>
                </div>

                <div class="col-lg-5 col-md-12">
                  <!-- Recordatorio de artículos dejados por el cliente -->
                  <div class="card border-warning-subtle shadow-sm bg-warning bg-opacity-10">
                    <div class="card-header bg-warning bg-opacity-25 py-2 d-flex justify-content-between align-items-center border-bottom border-warning-subtle">
                      <span class="fw-bold text-dark small">
                        <i class="bi bi-box-seam text-warning-emphasis me-1"></i> Artículos del Cliente (Devolver)
                      </span>
                      <span class="badge bg-warning text-dark border border-warning" *ngIf="details.work.clientItems?.length">
                        {{ details.work.clientItems!.length }}
                      </span>
                    </div>
                    <div class="card-body p-2">
                      <div *ngIf="details.work.clientItems && details.work.clientItems.length > 0; else noClientItemsHistory">
                        <p class="small text-muted mb-2"><i class="bi bi-info-circle me-1"></i>Artículos registrados que trajo el cliente:</p>
                        <ul class="list-group list-group-flush rounded border">
                          <li *ngFor="let item of details.work.clientItems" class="list-group-item list-group-item-light py-1 px-2 small d-flex align-items-center">
                            <i class="bi bi-arrow-return-right text-warning-emphasis me-2"></i>
                            <span class="fw-semibold">{{ item }}</span>
                          </li>
                        </ul>
                      </div>
                      <ng-template #noClientItemsHistory>
                        <p class="small text-muted mb-0 fst-italic py-1">
                          <i class="bi bi-dash-circle me-1"></i>Sin artículos adicionales registrados por el cliente.
                        </p>
                      </ng-template>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Botones de Acción -->
              <div class="d-flex justify-content-end gap-2">
                <button *ngIf="(authService.isManager$ | async) && details.work.currentStatus === 'Completed'" class="btn btn-warning" (click)="revertToInProgress(details.work.id!)" [disabled]="isRevertingStatus">
                  <span *ngIf="isRevertingStatus" class="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
                  Revertir a "En Progreso"
                </button>
                
                <button *ngIf="(authService.isManager$ | async) && details.work.currentStatus === 'Completed'" 
                        class="btn" 
                        [ngClass]="details.work.validatedByManager ? 'btn-outline-success' : 'btn-success'"
                        (click)="onValidateAndSave(details.work.id!, details.work.validatedByManager)" 
                        [disabled]="isSavingValidation">
                  <span *ngIf="isSavingValidation" class="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
                  <i class="bi" [ngClass]="details.work.validatedByManager ? 'bi-arrow-repeat' : 'bi-check-lg'"></i>
                  {{ details.work.validatedByManager ? 'Actualizar Modificaciones' : 'Validar y Guardar' }}
                </button>
              </div>

            </div>
          </div>
        </ng-container>
        <ng-template #loadingDetails>
          <div class="text-center p-5">Cargando detalles...</div>
        </ng-template>
      </div>
      <ng-template #noWorkSelected>
        <div class="alert alert-info">Seleccione un trabajo de la lista para ver sus detalles.</div>
      </ng-template>
    </div>
  </div>

  <!-- MODAL EXPORTAR A CSV -->
  <div class="modal fade" #exportModal id="exportModal" tabindex="-1">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Exportar Historial</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
        </div>
        <div class="modal-body">
          <p class="text-muted small">Selecciona el rango de fechas de recepción para descargar las órdenes completadas.</p>
          <div class="mb-3">
            <label class="form-label fw-bold">Fecha de Inicio</label>
            <input type="date" class="form-control" [formControl]="exportStartDate">
          </div>
          <div class="mb-3">
            <label class="form-label fw-bold">Fecha de Fin</label>
            <input type="date" class="form-control" [formControl]="exportEndDate">
          </div>
        </div>
        <div class="modal-footer border-0">
          <button type="button" class="btn btn-secondary rounded-pill px-3" data-bs-dismiss="modal">Cancelar</button>
          <button type="button" class="btn btn-success rounded-pill px-4 shadow-sm" (click)="exportToCSV()">
            <i class="bi bi-download me-1"></i> Descargar CSV
          </button>
        </div>
      </div>
    </div>
  </div>

</div>